import CIcon from '@coreui/icons-react'
import { CSidebar, CSidebarBrand, CSidebarNav, CSidebarToggler } from '@coreui/react-pro'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SimpleBar from 'simplebar-react'
import 'simplebar/dist/simplebar.min.css'
import { logoNegative } from 'src/assets/brand/logo-negative'
import { logoNegativeDark } from 'src/assets/brand/logo-negative-dark'
import { logoSmall } from 'src/assets/brand/logo-small'
import { logoSmallDark } from 'src/assets/brand/logo-small-dark'
import { isUserEmployee } from 'src/selectors/AuthSelector'
import { isDarkTheme } from 'src/selectors/ThemeSelector'
import navigation from '../_nav'
import { AppSidebarNav } from './AppSidebarNav'

const AppSidebar = () => {
  const dispatch = useDispatch()
  const unfoldable = useSelector((state) => state.sidebar.sidebarUnfoldable)
  const sidebarShow = useSelector((state) => state.sidebar.sidebarShow)
  const auth = useSelector((state) => state.auth)
  const isDark = useSelector(isDarkTheme)
  const isEmployee = useSelector(isUserEmployee)

  const permissions = auth.permissions.map((p) => {
    return p.name
  })

  const authNav = navigation.filter((n) => {
    return (
      (n.permissions ? n.permissions.find((np) => permissions.includes(np)) : false) &&
      (isEmployee ? n.name !== 'dashboard' : n.name !== 'dashboards')
    )
  })

  return (
    <CSidebar
      position="fixed"
      unfoldable={!unfoldable}
      visible={sidebarShow}
      colorScheme="light"
      // onVisibleChange={(visible) => {
      //   dispatch({ type: 'set', sidebarShow: visible })
      // }}
    >
      <CSidebarBrand className="d-md-flex" to="/">
        <CIcon
          className="sidebar-brand-full"
          icon={isDark ? logoNegativeDark : logoNegative}
          height={35}
        />
        <CIcon
          className="sidebar-brand-narrow px-2"
          icon={isDark ? logoSmallDark : logoSmall}
          height={35}
        />
      </CSidebarBrand>
      <CSidebarNav>
        <SimpleBar>
          <AppSidebarNav items={authNav} />
        </SimpleBar>
      </CSidebarNav>
      <CSidebarToggler
        className="d-none d-lg-flex"
        onClick={() => dispatch({ type: 'set', sidebarUnfoldable: !unfoldable })}
      />
    </CSidebar>
  )
}

export default React.memo(AppSidebar)
